import { styled, Tooltip } from '@mui/material';
import React from 'react';

// const ButtonStyled = styled('button')({
//     padding: 0,
//     margin: 0,
//     background: 'transparent',
//     border: 'unset',
//     minHeight: 'unset',
//     minWidth: 'unset',
//     textAlign:"start"
// });
function CustomTooltip({ title = 'hello world', children, ...props }) {
    return (
        <Tooltip
            title={title}
            arrow
            enterTouchDelay={0}
            leaveTouchDelay={2000}
            slotProps={{
                tooltip: {
                    sx: { fontSize: '0.8rem' },
                },
            }}
            {...props}
        >
            {children}
            {/* <ButtonStyled type="button"></ButtonStyled> */}
        </Tooltip>
    );
}

export default CustomTooltip;
